import { Injectable } from '@angular/core';
import { CommonService } from '../../../service/common.service';
import * as series from '../../../config/series';
import { EChartOption } from 'echarts';
import * as background from '../../../config/backgroundColor';
import * as color from '../../../config/colors'

@Injectable({
  providedIn: 'root'
})
export class RingPieService {

  constructor(
    private commonService: CommonService,
  ) { }
  getChartTitle(value) {
    return {
      text: value.name,
      left: '50%',
      top: '70%',
      textAlign: 'center',
      textStyle: {
        fontFamily: 'notoSans',
        fontWeight: 'normal',
        fontSize: this.commonService.changeFontSize().fontSize,
        color: value.color[0],
        textAlign: 'center',
      },
    }
  }
  getChartSeries(value) {
    return series.getRingPieSeries(this.commonService.changeFontSize(), value);
    // return {
    //   name: value.name,
    //   type: 'pie',
    //   clockWise: false,
    //   radius: [30, 40],
    //   itemStyle: {
    //     normal: {
    //       color: value.color[0],
    //       shadowColor: value.color[0],
    //       shadowBlur: 0,
    //       label: {
    //         show: false
    //       },
    //       labelLine: {
    //         show: false
    //       },
    //     }
    //   },
    //   hoverAnimation: false,
    //   center: ['50%', '50%'],
    //   data: [{
    //     value: value.data,
    //     label: {
    //       normal: {
    //         formatter: function (params) {
    //           return params.value + '\n' + (params.value / value.total * 100).toFixed(0) + '%';
    //         },
    //         position: 'center',
    //         show: true,
    //         textStyle: {
    //           fontSize: this.commonService.changeFontSize().fontSize,
    //           fontWeight: 'bold',
    //           color: value.color[0]
    //         }
    //       }
    //     },
    //   }, {
    //     value: value.total-value.data,
    //     name: 'invisible',
    //     itemStyle: {
    //       normal: {
    //         color: value.color[1]
    //       },
    //       emphasis: {
    //         color: value.color[1]
    //       }
    //     }
    //   }]
    // }
  }
  getBgColor(darkMode){
    if (darkMode) {
      return {fontColor:color.darkModeTextColor,bgColor:background.darkModeBGColor};
    }else{
      return {fontColor:color.darkTextColor,bgColor:background.backgroundColor};
    }
  }
}
